document.addEventListener('DOMContentLoaded', function() {

  // ------------------------------------------------------
  // 1. CONTADORES DE TIEMPO (Top Bar y Oferta Principal)
  // ------------------------------------------------------
  
  // Contador Barra Superior (15 minutos)
  function startFlashSaleCountdown(duration, display) {
      let timer = duration, minutes, seconds;
      const interval = setInterval(function () {
          minutes = parseInt(timer / 60, 10);
          seconds = parseInt(timer % 60, 10);
          minutes = minutes < 10 ? "0" + minutes : minutes;
          seconds = seconds < 10 ? "0" + seconds : seconds;
          
          if(display) display.textContent = minutes + ":" + seconds;
          
          if (--timer < 0) {
              clearInterval(interval);
              if(display) display.textContent = "00:00";
          }
      }, 1000);
  }
  
  const flashSaleDisplay = document.querySelector('#flash-sale-countdown');
  if (flashSaleDisplay) {
      startFlashSaleCountdown(60 * 15, flashSaleDisplay);
  }

  // Contador Caja de Oferta (Cuerpo)
  function startMainCountdown(duration) {
      let timer = duration, minutes, seconds;
      const offerContainer = document.getElementById('offerCountdownContainer');
      
      if (!offerContainer) return;
      
      const interval = setInterval(function () {
          minutes = parseInt(timer / 60, 10);
          seconds = parseInt(timer % 60, 10);
          minutes = minutes < 10 ? "0" + minutes : minutes;
          seconds = seconds < 10 ? "0" + seconds : seconds;
          
          const countdownHTML = `
            <div class="countdown-segment"><div class="countdown-number">${minutes}</div><div class="countdown-label">Minutos</div></div>
            <div class="countdown-segment"><div class="countdown-number">${seconds}</div><div class="countdown-label">Segundos</div></div>
          `;
          offerContainer.innerHTML = countdownHTML;
          
          if (--timer < 0) {
              clearInterval(interval);
              offerContainer.innerHTML = `
                <div class="countdown-segment"><div class="countdown-number">00</div><div class="countdown-label">Minutos</div></div>
                <div class="countdown-segment"><div class="countdown-number">00</div><div class="countdown-label">Segundos</div></div>
              `;
          }
      }, 1000);
  }
  startMainCountdown(60 * 15);

  // ------------------------------------------------------
  // 2. ACORDEÓN DE PREGUNTAS FRECUENTES (FAQ)
  // ------------------------------------------------------
  document.querySelectorAll('.faq-question').forEach(q => {
    q.addEventListener('click', () => {
      const wasActive = q.classList.contains('active');
      // Cierra todos los demás
      document.querySelectorAll('.faq-question.active').forEach(el => {
          el.classList.remove('active');
          el.nextElementSibling.style.maxHeight = null;
      });
      // Abre el clickeado si no estaba abierto
      if (!wasActive) {
          q.classList.add('active');
          q.nextElementSibling.style.maxHeight = q.nextElementSibling.scrollHeight + 'px';
      }
    });
  });

  // ------------------------------------------------------
  // 3. LÓGICA DE CARRUSELES (Ebooks, Testimonios, Nuevo)
  // ------------------------------------------------------
  function setupCarousel(selector, autoScroll) {
    const carousel = document.querySelector(selector);
    if (!carousel) return;
    
    const slides = carousel.querySelector('.carousel-slides');
    const slideList = carousel.querySelectorAll('.carousel-slide');
    const prevButton = carousel.querySelector('.prev');
    const nextButton = carousel.querySelector('.next');
    const dotsContainer = carousel.querySelector('.carousel-dots');
    
    if(!slides || slideList.length === 0) return;

    let currentIndex = 0;
    const slideCount = slideList.length;
    let autoScrollInterval;

    // Crear puntos (dots)
    if (dotsContainer) {
        dotsContainer.innerHTML = '';
        for (let i = 0; i < slideCount; i++) {
            const dot = document.createElement('span'); 
            dot.classList.add('dot');
            dot.addEventListener('click', () => { 
                goToSlide(i); 
                if (autoScroll) clearInterval(autoScrollInterval); 
            });
            dotsContainer.appendChild(dot);
        }
    }
    
    const dots = dotsContainer ? dotsContainer.querySelectorAll('.dot') : [];

    function goToSlide(index) {
        slides.style.transform = 'translateX(' + (-index * 100) + '%)';
        if (dots.length > 0) { 
            dots.forEach(d => d.classList.remove('active')); 
            if(dots[index]) dots[index].classList.add('active'); 
        }
        currentIndex = index;
    }

    const nextSlide = () => goToSlide((currentIndex + 1) % slideCount);
    const prevSlide = () => goToSlide((currentIndex - 1 + slideCount) % slideCount);

    if (prevButton) prevButton.addEventListener('click', () => { prevSlide(); if (autoScroll) clearInterval(autoScrollInterval); });
    if (nextButton) nextButton.addEventListener('click', () => { nextSlide(); if (autoScroll) clearInterval(autoScrollInterval); });

    // Inicializar
    goToSlide(0);
    if (autoScroll) autoScrollInterval = setInterval(nextSlide, 4000);
  }

  // Inicializamos TODOS los carruseles existentes
  setupCarousel('#carousel-1', true);
  setupCarousel('#reviews-carousel-wrapper', false);
  setupCarousel('#testimonios-carrusel', false); 

  // ------------------------------------------------------
  // 4. CARRUSEL HERO (NUEVO - Reemplazo del video)
  // ------------------------------------------------------
  function setupHeroCarousel() {
    const heroCarousel = document.getElementById('hero-carousel');
    if (!heroCarousel) return;
    
    const slidesContainer = heroCarousel.querySelector('.carousel-slides');
    const slides = heroCarousel.querySelectorAll('.carousel-slide');
    const prevBtn = heroCarousel.querySelector('.carousel-btn.prev');
    const nextBtn = heroCarousel.querySelector('.carousel-btn.next');
    const dotsContainer = heroCarousel.querySelector('.carousel-dots');
    
    if (!slidesContainer || slides.length === 0) return;
    
    let currentSlide = 0;
    const totalSlides = slides.length;
    let autoSlideInterval;
    
    if (dotsContainer && dotsContainer.children.length === 0) {
        slides.forEach((_, index) => {
            const dot = document.createElement('span');
            dot.classList.add('dot');
            if (index === 0) dot.classList.add('active');
            dot.addEventListener('click', () => {
                goToSlide(index);
                resetAutoSlide();
            });
            dotsContainer.appendChild(dot);
        });
    }
    
    const dots = dotsContainer ? dotsContainer.querySelectorAll('.dot') : [];
    
    function goToSlide(slideIndex) {
        currentSlide = slideIndex;
        updateCarousel();
    }
    
    function updateCarousel() {
        slidesContainer.style.transform = `translateX(-${currentSlide * 100}%)`;
        dots.forEach((dot, index) => {
            dot.classList.toggle('active', index === currentSlide);
        });
    }
    
    function resetAutoSlide() {
        if (autoSlideInterval) clearInterval(autoSlideInterval);
        autoSlideInterval = setInterval(() => {
            currentSlide = (currentSlide + 1) % totalSlides;
            updateCarousel();
        }, 5000);
    }
    
    if (prevBtn) {
        prevBtn.addEventListener('click', () => {
            currentSlide = (currentSlide - 1 + totalSlides) % totalSlides;
            updateCarousel();
            resetAutoSlide();
        });
    }
    
    if (nextBtn) {
        nextBtn.addEventListener('click', () => {
            currentSlide = (currentSlide + 1) % totalSlides;
            updateCarousel();
            resetAutoSlide();
        });
    }
    
    heroCarousel.addEventListener('mouseenter', () => {
        if (autoSlideInterval) clearInterval(autoSlideInterval);
    });
    
    heroCarousel.addEventListener('mouseleave', resetAutoSlide);
    
    updateCarousel();
    resetAutoSlide();
  }
  
  setupHeroCarousel();

  // ------------------------------------------------------
  // 5. VIDEO PLAYER (Mira el libro por dentro)
  // ------------------------------------------------------
  const video = document.getElementById('book-preview-video');
  const playButton = document.getElementById('play-button');
  const videoWrapper = document.querySelector('.video-wrapper');

  if (video && playButton && videoWrapper) {
      playButton.addEventListener('click', function() {
          if (video.paused) {
              video.play();
              videoWrapper.classList.add('playing');
          } else {
              video.pause();
              videoWrapper.classList.remove('playing');
          }
      });

      video.addEventListener('pause', function() {
          videoWrapper.classList.remove('playing');
      });
      
      video.addEventListener('ended', function() {
          videoWrapper.classList.remove('playing');
      });
  }

  // ------------------------------------------------------
  // 6. SIMULACIÓN DE VISITANTES EN VIVO
  // ------------------------------------------------------
  function startViewerCount() {
    const viewerCountElements = document.querySelectorAll('.viewer-count');
    if (viewerCountElements.length === 0) return;
    
    let count = Math.floor(Math.random() * (120 - 80 + 1) + 80); 
    viewerCountElements.forEach(el => el.textContent = count);
    
    setInterval(() => {
        const increment = Math.floor(Math.random() * 3) - 1; 
        count += increment;
        if (count < 60) count = 60; 
        viewerCountElements.forEach(el => el.textContent = count);
    }, 4500); 
  }
  startViewerCount();

  // ------------------------------------------------------
  // 7. STICKY CTA (Botón flotante en móvil)
  // ------------------------------------------------------
  window.addEventListener('scroll', function() {
    const stickyCta = document.getElementById('sticky-cta');
    if (!stickyCta) return;

    const scrollTop = window.scrollY;
    const docHeight = document.body.scrollHeight - window.innerHeight;
    const scrollPercent = (scrollTop / docHeight) * 100;
    
    if (scrollPercent > 35) {
        stickyCta.classList.add('visible');
    } else {
        stickyCta.classList.remove('visible');
    }
  });


  // ------------------------------------------------------
  // 8. NOTIFICACIONES DE VENTA (Versión Argentina 🇦🇷)
  // ------------------------------------------------------
  const salesData = [
    { name: "Luciana M.", location: "Córdoba Capital" },
    { name: "Beatriz S.", location: "Rosario, Santa Fe" },
    { name: "Camila R.", location: "Palermo, CABA" },
    { name: "Florencia G.", location: "Mendoza" },
    { name: "Marta P.", location: "Lanús, Buenos Aires" },
    { name: "Julieta T.", location: "Salta" },
    { name: "Valentina L.", location: "Mar del Plata" },
    { name: "Sofía B.", location: "San Miguel de Tucumán" },
    { name: "Ana Laura D.", location: "Neuquén" },
    { name: "Claudia R.", location: "La Plata" },
    { name: "Mariana F.", location: "San Isidro, GBA" },
    { name: "Romina V.", location: "Corrientes" }
  ];

  const notifElement = document.getElementById('sales-notification');
  const notifFlag = document.getElementById('notif-flag');
  const notifMessage = document.getElementById('notif-message');

  function showNotification() {
      if(!notifElement || !notifFlag || !notifMessage) return;

      const randomSale = salesData[Math.floor(Math.random() * salesData.length)];
      notifFlag.textContent = "🇦🇷";
      notifMessage.innerHTML = `<strong>${randomSale.name}</strong> de ${randomSale.location} acaba de comprar el <strong>Sistema Smart Freezer</strong>.`;
      
      notifElement.classList.add('visible');
      setTimeout(() => {
          notifElement.classList.remove('visible');
      }, 5000); 
  }

  setTimeout(() => {
      showNotification();
      setInterval(showNotification, 30000); 
  }, 10000);

  // ------------------------------------------------------
  // 9. BOTÓN "ENVIAR RESEÑA" (Modal)
  // ------------------------------------------------------
  const openReviewBtn = document.getElementById('open-review-modal-btn');
  if (openReviewBtn) {
    openReviewBtn.addEventListener('click', function() {
      let modal = document.getElementById('review-modal');
      if (!modal) {
        modal = document.createElement('div');
        modal.id = 'review-modal';
        modal.innerHTML = `<div class="modal-content"><button id="close-modal" class="modal-close">&times;</button><h2>Enviar tu Reseña</h2><p>Compartí tu experiencia:</p><form id="review-form"><div class="form-group"><label>Tu nombre:</label><input type="text" required></div><div class="form-group"><label>Tu valoración:</label><div class="star-rating"><span class="star" data-rating="1">★</span><span class="star" data-rating="2">★</span><span class="star" data-rating="3">★</span><span class="star" data-rating="4">★</span><span class="star" data-rating="5">★</span></div><input type="hidden" id="rating-value" value="5" required></div><div class="form-group"><label>Tu reseña:</label><textarea required rows="4" placeholder="Contanos tu experiencia..."></textarea></div><div class="form-buttons"><button type="submit">Enviar Reseña</button><button type="button" id="cancel-review">Cancelar</button></div></form></div>`;
        document.body.appendChild(modal);
        
        const stars = modal.querySelectorAll('.star');
        const ratingInput = modal.querySelector('#rating-value');
        stars.forEach(star => {
          star.addEventListener('click', function() {
            const rating = parseInt(this.getAttribute('data-rating'));
            ratingInput.value = rating;
            stars.forEach((s, index) => { index < rating ? s.classList.add('active') : s.classList.remove('active'); });
          });
        });
        
        const closeModal = () => { modal.classList.remove('visible'); setTimeout(() => modal.style.display = 'none', 300); };
        modal.querySelector('#close-modal').addEventListener('click', closeModal);
        modal.querySelector('#cancel-review').addEventListener('click', closeModal);
        modal.addEventListener('click', (e) => { if (e.target === modal) closeModal(); });
        modal.querySelector('#review-form').addEventListener('submit', function(e) {
          e.preventDefault();
          alert(`¡Gracias por tu reseña!`);
          closeModal();
          this.reset();
        });
      }
      modal.style.display = 'flex';
      setTimeout(() => modal.classList.add('visible'), 10);
    });
  }

  // ------------------------------------------------------
  // 10. LÓGICA DE MÓDULOS (Smart Freezer Pack)
  // ------------------------------------------------------
  const mods = ['d3m1', 'd3m2', 'd3m3', 'd3m4', 'd3m5'];
  let allOpen = false;

  window.updateProgress = function() {
    const opened = mods.filter(id => {
      const el = document.getElementById(id);
      return el && el.classList.contains('active');
    }).length;
    
    const bar = document.getElementById('progressBar');
    const label = document.getElementById('progressLabel');
    if(bar) bar.style.width = (opened / mods.length * 100) + '%';
    if(label) label.textContent = `${opened} de ${mods.length} módulos abiertos`;
  };

  window.d3toggle = function(id) {
    const el = document.getElementById(id);
    if(el) {
      el.classList.toggle('active');
      window.updateProgress();
    }
  };

  window.expandAll = function() {
    allOpen = !allOpen;
    mods.forEach(id => {
      const el = document.getElementById(id);
      if(el) {
        allOpen ? el.classList.add('active') : el.classList.remove('active');
      }
    });
    const expandBtn = document.querySelector('.d3-expand-all');
    if(expandBtn) expandBtn.textContent = allOpen ? 'Cerrar todos ↑' : 'Ver todos ↓';
    window.updateProgress();
  };

  window.updateProgress();

}); // Fin del DOMContentLoaded